export const WEB_MINWIDTH = 1200;
export const WEB_WIDTH = 1200;
export const WEB_GRID_GAP = 12;
